import React from "react";
import { ShieldCheck } from "lucide-react";
import logo from "../assets/image/logo.svg";

const Pill = () => (
  <span className="inline-flex items-center gap-8 text-[#1E1E1E] text-[12px]">
    <div className="flex gap-2 items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
      >
        <path
          d="M14 8V6C14 3.23858 11.7614 1 9 1C6.23858 1 4 3.23858 4 6V8M9 12.5V14.5M5.8 19H12.2C13.8802 19 14.7202 19 15.362 18.673C15.9265 18.3854 16.3854 17.9265 16.673 17.362C17 16.7202 17 15.8802 17 14.2V12.8C17 11.1198 17 10.2798 16.673 9.63803C16.3854 9.07354 15.9265 8.6146 15.362 8.32698C14.7202 8 13.8802 8 12.2 8H5.8C4.11984 8 3.27976 8 2.63803 8.32698C2.07354 8.6146 1.6146 9.07354 1.32698 9.63803C1 10.2798 1 11.1198 1 12.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
          stroke="#2A8BF7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <p className="opacity-50 text-[12px] text-[#1E1E1E]">SSL Encrypted</p>
    </div>
    <div className="flex gap-2 items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7.96668 14.7219L7 22L11.5884 19.247C11.7381 19.1572 11.8129 19.1123 11.8928 19.0947C11.9634 19.0792 12.0366 19.0792 12.1072 19.0947C12.1871 19.1123 12.2619 19.1572 12.4116 19.247L17 22L16.0343 14.7212M19 9C19 12.866 15.866 16 12 16C8.13401 16 5 12.866 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9Z"
          stroke="#2A8BF7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <p className="opacity-50 text-[12px] text-[#1E1E1E]">Under licence</p>
    </div>
  </span>
);

const List = ({ title, items }) => (
  <div>
    <h4 className="mb-4 text-[14px] font-semibold text-[#1E1E1E] opacity-75">
      {title}
    </h4>
    <ul className="space-y-1 opacity-50 text-[#000025] text-[14px]">
      {items.map((t) => (
        <li key={t}>
          <button type="button" className="hover:text-slate-900 text-left">
            {t}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

const Brand = () => (
  <div className="md:w-1/4">
    <div className="flex items-center gap-2">
      <img src={logo} alt="ProtectPay" className="w-[195px] h-[42px]" />
    </div>
    <p className="mt-4 text-page-subtitle font-normal text-[#1E1E1E] opacity-50">
      Here is what’s happening with your escrow transactions this week.
    </p>
    <div className="mt-4 flex items-center gap-8">
      <Pill />
    </div>
  </div>
);

const PublicFooter = () => {
  return (
    <footer className="w-full bg-bgColor">
      <div className="bg-white p-1 py-4 lg:p-6">
        <div className="mx-auto max-w-[1432px] px-4 w-full">
          <div className="flex flex-col md:flex-row gap-8 justify-between">
            <Brand />

            <div className="flex flex-col md:flex-row gap-8 lg:gap-32">
              <List
                title="Quick access"
                items={[
                  "Dashboard",
                  "My listings",
                  "Buyer requests",
                  "Transactions",
                  "My profile",
                  "Settings",
                ]}
              />

              <List
                title="Legal"
                items={[
                  "Terms of service",
                  "Privacy policy",
                  "Escrow agreement",
                  "Dispute resolution",
                  "Compliance",
                ]}
              />

              <div>
                <h4 className="mb-4 text-[14px] font-semibold text-[#1E1E1E] opacity-75">
                  Contact & help
                </h4>
                <ul className="space-y-2 text-[#000025] text-[14px]">
                  <li className="flex items-center gap-2 text-[#1E1E1E]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21.5 18L14.8571 12M9.14286 12L2.50003 18M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z"
                        stroke="#2A8BF7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>{" "}
                    <div className="opacity-50">protectpay@support.com</div>
                  </li>
                  <li className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M8.38028 8.85335C9.07627 10.303 10.0251 11.6616 11.2266 12.8632C12.4282 14.0648 13.7869 15.0136 15.2365 15.7096C15.3612 15.7694 15.4235 15.7994 15.5024 15.8224C15.7828 15.9041 16.127 15.8454 16.3644 15.6754C16.4313 15.6275 16.4884 15.5704 16.6027 15.4561C16.9523 15.1064 17.1271 14.9316 17.3029 14.8174C17.9658 14.3864 18.8204 14.3864 19.4833 14.8174C19.6591 14.9316 19.8339 15.1064 20.1835 15.4561L20.3783 15.6509C20.9098 16.1824 21.1755 16.4481 21.3198 16.7335C21.6069 17.301 21.6069 17.9713 21.3198 18.5389C21.1755 18.8242 20.9098 19.09 20.3783 19.6214L20.2207 19.779C19.6911 20.3087 19.4263 20.5735 19.0662 20.7757C18.6667 21.0001 18.0462 21.1615 17.588 21.1601C17.1751 21.1589 16.8928 21.0788 16.3284 20.9186C13.295 20.0576 10.4326 18.4332 8.04466 16.0452C5.65668 13.6572 4.03221 10.7948 3.17124 7.76144C3.01103 7.19699 2.93092 6.91477 2.9297 6.50182C2.92833 6.0436 3.08969 5.42311 3.31411 5.0236C3.51636 4.66357 3.78117 4.39876 4.3108 3.86913L4.46843 3.7115C4.99987 3.18006 5.2656 2.91433 5.55098 2.76999C6.11854 2.48292 6.7888 2.48292 7.35636 2.76999C7.64174 2.91433 7.90747 3.18006 8.43891 3.7115L8.63378 3.90637C8.98338 4.25597 9.15819 4.43078 9.27247 4.60655C9.70347 5.26945 9.70347 6.12403 9.27247 6.78692C9.15819 6.96269 8.98338 7.1375 8.63378 7.4871C8.51947 7.60142 8.46231 7.65857 8.41447 7.72538C8.24446 7.96281 8.18576 8.30707 8.26748 8.58743C8.29048 8.66632 8.32041 8.72866 8.38028 8.85335Z"
                        stroke="#2A8BF7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>{" "}
                    <div className="opacity-50">+00 000 000 00</div>
                  </li>
                  <li className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                        stroke="#2A8BF7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
                        stroke="#2A8BF7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>{" "}
                    <div className="opacity-50"> Country</div>
                  </li>
                </ul>
                <p className="mt-2 text-[12px] opacity-50 text-[#1E1E1E]">
                  Support available 24/7 in English.
                </p>
              </div>
            </div>
          </div>

          <hr className="mb-8 mt-8 border-[#1E1E1E26]" />

          <div className="flex flex-col items-start justify-between gap-3 text-[12px] text-[#1E1E1E] md:flex-row font-medium opacity-50">
            <p>
              © 2025 ProtectPay. All rights reserved. Licensed escrow service
              provider.
            </p>
            <p className="flex items-center gap-2">
              Secured by <ShieldCheck size={14} /> Escrow level type security
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
